import { Card, CardActionArea, CardContent, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/components/PageHeader';

const tiles = [
  {
    to: '/admin/providers',
    title: 'Provider configs',
    description: 'OAuth client credentials for Google, Microsoft, etc.',
  },
  {
    to: '/admin/users',
    title: 'Users',
    description: 'JIT-provisioned by your IdP. Read-only.',
  },
  {
    to: '/admin/audit',
    title: 'Audit log',
    description: 'User-configured actions across the system.',
  },
];

export function AdminLanding() {
  const navigate = useNavigate();
  return (
    <Container maxWidth="lg" disableGutters>
      <PageHeader title="Admin" subtitle="System-wide configuration and observability." />
      <Grid container spacing={2}>
        {tiles.map((tile) => (
          <Grid key={tile.to} size={{ xs: 12, sm: 6, md: 4 }}>
            <Card variant="outlined">
              <CardActionArea onClick={() => navigate(tile.to)} sx={{ p: 1 }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {tile.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {tile.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
